<template>
  <section id="top" class="relative overflow-hidden bg-graphite-900 pt-24 sm:pt-[148px]">
    <div class="pointer-events-none absolute inset-0 opacity-[0.05]" aria-hidden="true">
      <svg class="h-full w-full" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
            <path d="M40 0H0V40" fill="none" stroke="white" stroke-width="1" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#grid)" />
      </svg>
    </div>

    <div class="pointer-events-none absolute inset-y-0 right-0 hidden w-1/3 bg-brand-800 [clip-path:polygon(30%_0,100%_0,100%_100%,0_100%)] lg:block" aria-hidden="true"></div>

    <div class="relative mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-20 lg:px-8">
      <div class="max-w-3xl border-l-4 border-brand-600 pl-6">
        <span class="text-xs font-bold uppercase tracking-[0.2em] text-brand-400">
          Obróbka metalu &middot; Produkcja na zamówienie
        </span>

        <h1 class="mt-5 text-4xl font-black leading-[1.1] tracking-tight text-white sm:text-5xl lg:text-[3.4rem]">
          Precyzyjna obróbka metalu —
          <span class="text-graphite-300">od projektu po gotowy element</span>
        </h1>

        <p class="mt-6 max-w-2xl text-lg leading-relaxed text-graphite-300">
          Monteco realizuje kompleksowe zlecenia dla firm produkcyjnych i przemysłowych: projektowanie,
          cięcie, gięcie, spawanie, malowanie i cynkowanie — jeden partner, jedna odpowiedzialność,
          dotrzymane terminy.
        </p>

        <div class="mt-10 flex flex-col gap-4 sm:flex-row">
          <a href="#kontakt" class="btn-primary">
            Zapytaj o wycenę
          </a>
          <a href="#uslugi" class="btn-secondary">
            Zobacz nasze usługi
          </a>
        </div>
      </div>
    </div>

    <dl class="relative grid grid-cols-2 divide-x divide-y divide-white/10 border-t border-white/10 sm:grid-cols-4 sm:divide-y-0">
      <div v-for="stat in stats" :key="stat.label" class="px-6 py-6 sm:px-8">
        <dt class="text-2xl font-black text-white sm:text-3xl">{{ stat.value }}</dt>
        <dd class="mt-1 text-xs font-semibold uppercase tracking-wide text-graphite-400">{{ stat.label }}</dd>
      </div>
    </dl>
  </section>
</template>

<script>
export default {
  name: 'HeroSection',
  data() {
    return {
      stats: [
        { value: '8', label: 'usług w jednym miejscu' },
        { value: '100%', label: 'kontroli jakości' },
        { value: '1', label: 'partner na każdym etapie' },
        { value: 'B2B', label: 'zlecenia produkcyjne' }
      ]
    };
  }
};
</script>
